module.exports = __webpack_public_path__ + "assets/ccr.696355d0.svg";